module.exports = __webpack_public_path__ + "static/media/chat.a35943d6.svg";